export const dataPasswords = [
  { id: "oldPwd", placeholder: "Vieja contraseña" },
  { id: "newPwd", placeholder: "Nueva contraseña" },
  { id: "confirmaPwd", placeholder: "Confirmá tu nueva contraseña" },
];
